import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';

import CheckoutPage from 'pages/Checkout';
import OrderSuccess from 'pages/Checkout/OrderSuccess';

import NotFound from 'components/NotFound';

import CoreRoute from 'routes/CoreRoute';
import PATHS from 'routes/paths';

function Checkout() {
  return (
    <Router>
      <Switch>
        <Route
          path={PATHS.checkout}
          render={(routeProps) => (
            <CoreRoute title="Checkout">
              <CheckoutPage {...routeProps} />
            </CoreRoute>
          )}
        />
        <Route
          path={PATHS.orderSuccess}
          render={(routeProps) => (
            <CoreRoute>
              <OrderSuccess {...routeProps} />
            </CoreRoute>
          )}
        />
        <Route path="*">
          <NotFound />
        </Route>
      </Switch>
    </Router>
  );
}

export default Checkout;
